import {
  AccountBalance,
  CalendarToday,
  Euro,
  Home,
  MenuBook,
  Payment,
  SwapHoriz,
} from '@material-ui/icons';
import CommentIcon from '@material-ui/icons/Comment';
import PaymentIcon from '@material-ui/icons/Payment';
import { useContextAuthManager } from 'components/AuthManager';
import { EmptyStateWithText } from 'components/EmptyState';
import routePaths from 'constants/route-paths';
import { Namespace } from 'locales';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AsideListIconComponent, { AsideListIcon } from '../../common/AsideIconMenuItem';

const ConfigurationAsideMenu = () => {
  const { t } = useTranslation(Namespace.invoicing);
  const { user } = useContextAuthManager();

  const asideListIcons: AsideListIcon[] = [
    {
      label: t('house_data'),
      routePath: routePaths.CONFIGURATION_HOUSE_DATA,
      muiIcon: AccountBalance,
    },
    {
      label: t('house_division'),
      routePath: routePaths.CONFIGURATION_HOUSE_DIVISIONS,
      muiIcon: Home,
    },
    {
      label: t('roster'),
      routePath: routePaths.CONFIGURATION_ROSTER,
      muiIcon: CalendarToday,
    },
    {
      label: t('indicators_transmission'),
      routePath: routePaths.CONFIGURATION_INDICATORS_TRANSMISSION,
      muiIcon: SwapHoriz,
    },
    // Future feature (Config nursing documentation)
    // {
    //   label: t('nursing_documentation'),
    //   routePath: routePaths.CONFIGURATION_CARE_DOCUMENTATION,
    //   muiIcon: AssignmentIcon,
    // },
    {
      label: t('standard_texts'),
      routePath: routePaths.CONFIGURATION_SUGGESTIONS,
      muiIcon: CommentIcon,
    },
    {
      label: t('fibu_system_configuration'),
      routePath: routePaths.CONFIGURATION_FIBU,
      muiIcon: MenuBook,
    },
  ];

  if (user?.nursingHome.license.invoicingEnabledFrom) {
    asideListIcons.push({
      label: t('invoicing'),
      routePath: routePaths.CONFIGURATION_INVOICING,
      muiIcon: Euro,
    });
    asideListIcons.push({
      label: t('booking_accounts'),
      routePath: routePaths.CONFIGURATION_BOOKING_ACCOUNTS,
      muiIcon: Payment,
    });
    asideListIcons.push({
      label: t('cash_items'),
      routePath: routePaths.CONFIGURATION_CASH_ITEMS,
      muiIcon: PaymentIcon,
    });
  }

  const [chosen, setChosen] = useState<string>();

  return (
    <div className="aside-menu">
      <ul className="menu-nav py-0">
        {asideListIcons.length ? (
          asideListIcons.map((listItem) => (
            <AsideListIconComponent
              key={listItem.label}
              icon={listItem}
              active={listItem.label === chosen}
              onClick={() => setChosen(listItem.label)}
            />
          ))
        ) : (
          <EmptyStateWithText text={t('no_results_for_current_settings')} verticalPositionTop />
        )}
      </ul>
    </div>
  );
};

export default ConfigurationAsideMenu;
